<!--
 * A Vue component that wraps the input element.
 *
 * Properties
 * ==========
 * - description -
 * (Optional) A description that appears below the input element.
 *
 * - autofocus -
 * (Optional) To set the autofocus property of the input element to true or false.
 *
-->
<template>
    <div>
        <label v-if="text" :for="elementId">
            {{ text }}
        </label>
        <input
            v-bind="$attrs"
            class="form-control"
            ref="inputField"
            :value="value"
            @input="$_onInput"
            @blur="$_onBlur"
            @change="$_onChange"
            @focus="$_onFocus"
            @keydown="$_onKeydown"
            @keyup="$_onKeyup"
            v-bind:class="extendedClass"
            :style="extendedStyle"
            trim
        />
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'base-input',
        props: {
            description: { type: String, default: '' },
            text: { type: String, default: '' },
            labelSize: { type: String, default: '' },
            value: [String, Number],
            extendedClass: { type: [String, Object], default: '' },
            extendedStyle: { type: [String, Object], default: '' },
            autofocus: { type: Boolean, required: false }
        },

        data() {
            return { element: null };
        },

        computed: {
            elementId() {
                return this.element && this.element.id;
            }
        },

        mounted() {
            this.element = this.$refs.inputField;

            // Adding autofocus attribute on input element is not working when page loads
            // So thats why this construction is used:
            if (this.autofocus) {
                this.$refs.inputField.focus();
            }
        },

        methods: {
            $_onBlur: function (input) {
                this.$emit('blur', input.target.value);
            },

            $_onChange: function (input) {
                this.$emit('change', input.target.value);
            },

            $_onFocus: function (input) {
                this.$emit('focus', input.target.value);
            },

            $_onInput: function (input) {
                this.$emit('input', input.target.value);
            },

            $_onKeyup(event) {
                this.$emit('keyup', event);
            },

            $_onKeydown(event) {
                this.$emit('keydown', event);
            }
        }
    };
</script>
